export enum EnumMenuOpHeaderPpto {
  Catalogos = 'MENSAJES.GRALS.CATALOGOS',
  Consultas = 'MENSAJES.GRALS.CONSULTAS',
  Procesos = 'MENSAJES.GRALS.PROCESOS',
  Factores = 'MENSAJES.GRALS.FACTORES',
  Presupuesto = 'MENSAJES.GRALS.PPTO',
  Reportes = 'MENSAJES.GRALS.IMPRIMIR'
}
export enum EnumMenuOpReportes {
  Viewer = 'Viewer',
  Designer = 'Designer',
  ViewerPDF = 'ViewerPDF'
}
export enum EnumMenuOpIDPpto {
  Presupuesto = 'Presupuesto',
  OpcionesPpto = 'OpcionesPpto',
  // MM = 'M-M',
  MA = 'M-A',
  CatalogosMat = 'CatalogosMat',
  CatalogosMo = 'CatalogosMo',
  CatalogosMaq = 'CatalogosMaq',
  CatalogosExpIns = 'CatalogosExpIns',
  CatalogosConstrubasePlus = 'CatalogosConstrubasePlus',
  CatalogosBusquedaIA = 'CatalogosBusquedaIA',
  CatalogosGeneralConstrubase = 'CatalogosGeneralConstrubase',
  ConsultasMatBas = 'ConsultasMatBas',
  ConsultasPptpComp = 'ConsultasPptpComp',
  ConsultasBusquedaGral = 'ConsultasBusquedaGral',
  ProcesosActCosMat = 'ProcesosActCosMat',
  ProcesosCalculo = 'ProcesosCalculo',
  ProcesosDetPpto = 'ProcesosDetPpto',
  ProcesosGuardarPpto = 'ProcesosGuardarPpto',
  FactoresSobrecosto = 'FactoresSobrecosto',
  FactoresFasar = 'FactoresFasar',
  PresupuestoRutaCritica = 'PresupuestoRutaCritica',
  PresupuestoTotalizar = 'PresupuestoTotalizar',
  RecibirArchivoIntercambio = 'RecibirArchivoIntercambio',
  DepurarPresupuesto = 'DepurarPresupuesto',
  UnirFileManager= 'UnirFileManager',
  RenumerarControlPPtoMatrices = 'RenumerarControlPPtoMatrices',
  ProgramacionObra = 'ProgramacionObra'
}
export enum EnumMenuOpHeaderPrincipal {
  Inicio = 'MENSAJES.GRALS.INICIO',
  Catalogos = 'MENSAJES.GRALS.CATALOGOS',
  Herramientas = 'MENSAJES.GRALS.HERRAMIENTAS',
  Vista = 'MENSAJES.GRALS.VISTA'
}
export enum EnumMenuOpIDPrincipal {
  PptoActivo = 'PptoActivo',
  PptoMaestro = 'PptoMaestro',
  InicioCatPpto = 'InicioCatPpto',
  Inicio = 'Inicio',
  Catalogos = 'Catálogos',
  Herramientas = 'Herramientas',
  Vista = 'Vista',
  Reportes = 'Reportes',
  CatalogosUnidad = 'CatalogosUnidad',
  CatalogosTipIns = 'CatalogosTipIns',
  CatalogosFamilia = 'CatalogosFamilia',
  CatalogosEdo = 'CatalogosEdo',
  CatalogosCiudad = 'CatalogosCiudad',
  CatalogosProv = 'CatalogosProv',
  CatalogosResp = 'CatalogosResp',
  CatalogosCli = 'CatalogosCli',
  CatalogosContactoCli = 'CatalogosContactoCli',
  CatalogosEmpresa = 'CatalogosEmpresa',
  CatalogosCalendario = 'CatalogosCalendario',
  CatalogosVendedor = 'CatalogosVendedor',
  CatalogosTipLic = 'CatalogosTipLic',
  CatalogosRegiones = 'CatalogosRegiones',
  HerramientasOpcion = 'HerramientasOpcion',
  VistaAcerca = 'VistaAcerca',
  VistaNuevo = 'VistaNuevo'
}
